import React from 'react'

// Translations
import { TRANSLATIONS } from 'pages/Career/utilities';
import { getTranslation } from 'translations';

//* Styles
import styles from './Jobs.module.scss';

const Jobs = () => {

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();

  return (
    <section className={styles["job-section"]}>
        <h4 className={styles["section1-title"]}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_title")}</h4>
        <p className={styles["section1-text1"]}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_text1")}</p>
        <ul className={styles['open-jobs-list']}>
            <li className={styles['open-job-position']}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_job1")}</li>
            <li className={styles['open-job-position']}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_job2")}</li>
            <li className={styles['open-job-position']}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_job3")}</li>
            <li className={styles['open-job-position']}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_job4")}</li>
        </ul>
        <div className={styles["section1-text2-content"]}>
            <p className={styles["section1-text2"]}>{getTranslation(TRANSLATIONS, LANG, "jobs_section1_text2")}</p>
            <a className={styles['mailto']} href="mailto:jobs@filotrack.com">jobs@filotrack.com</a>
        </div>
        <h4 className={styles['section2-title']}>{getTranslation(TRANSLATIONS, LANG, "jobs_section2_title")}</h4>
        <div className={styles["section2-text1-content"]}>
            <p className={styles["section2-text1"]}>{getTranslation(TRANSLATIONS, LANG, "jobs_section2_text1")}</p>
            <a className={styles['mailto']} href="mailto:jobs@filotrack.com">jobs@filotrack.com</a>
        </div>
    </section>
  )
}

export default Jobs